<!-- VARIATION ONE -->
@if (type === 'variation-one') {
<mat-form-field
  [ngStyle]="{ width: width }"
  class="variation-one"
  [ngClass]="{ 'mat-focused': isDropdownOpen }"
>
  <mat-select
    disableOptionCentering
    [value]="value"
    (selectionChange)="onChangeEvent($event)"
    (opened)="isDropdownOpen = true"
    (closed)="isDropdownOpen = false"
  >
    @for (item of options; track trackByFnGroup($index)) {
    <mat-option [value]="item.value">
      @if (item.labelKey) {
      {{ item.labelKey | translate }}
      }
    </mat-option>
    }
  </mat-select>
</mat-form-field>
}

<!-- VARIATION TWO -->
@if (type === 'variation-two') {
<mat-form-field
  [ngStyle]="{ width: width }"
  class="variation-two"
  [ngClass]="{ 'mat-focused': isDropdownOpen }"
>
  @if (icon) {
  <span class="icon">
    <firebird-web-icon [width]="'32px'" [name]="icon"> </firebird-web-icon>
  </span>
  }
  <mat-select
    #selector
    [(value)]="value"
    disableOptionCentering
    panelClass="variation-two-panelClass"
    (selectionChange)="onChangeEvent($event)"
    (opened)="isDropdownOpen = true"
    (closed)="isDropdownOpen = false"
  >
    @for (item of options; track trackByFnGroup($index)) {
    <mat-option [value]="item.value">
      @if (item.labelKey) {
      {{ item.labelKey | translate }}
      }
    </mat-option>
    }
  </mat-select>
</mat-form-field>
}

<!-- VARIATION THREE -->
@if (type === 'variation-three') {
<mat-form-field
  [ngStyle]="{ width: width }"
  class="variation-three"
  [ngClass]="{ 'mat-focused': isDropdownOpen }"
>
  <span class="icon">
    <firebird-web-icon [width]="'32px'" [height]="'32px'" [name]="icon">
    </firebird-web-icon>
  </span>
  @if (value && value !== null) {
  <div class="cities-dropdown">
    <mat-select
      disableOptionCentering
      [value]="value"
      panelClass="variation-two-panelClass"
      (opened)="isDropdownOpen = true"
      (closed)="isDropdownOpen = false"
    >
      @for (item of options; track trackByFnGroup($index)) {
      <mat-option [value]="item.value">
        @if (item.labelKey) {
        {{ item.labelKey | translate }}
        }
      </mat-option>
      }
    </mat-select>
    @if (cityName) {
    <div class="region-cities">{{ cityName | translate }}</div>
    }
  </div>
  }
</mat-form-field>
} @if (type === 'variation-four' && options?.length > 0) {
<mat-form-field
  class="variation-four"
  [ngClass]="{ 'mat-focused': isDropdownOpen }"
  [ngStyle]="{ width: width }"
>
  <mat-select
    [panelClass]="panelClass || 'variation-four-panelClass'"
    [value]="value"
    disableOptionCentering
    #selector
    (selectionChange)="onChangeEvent($event)"
    (opened)="isDropdownOpen = true"
    (closed)="isDropdownOpen = false"
  >
    <mat-select-trigger>
      @if ( !isMultiContinentInCustomList && !customListRunDateConfig) {
      {{ getRunDateLabel(value) | dateWithoutTimezone : dateFormat }}
      <span class="run-date-type">
        {{ getRunDateType(value) | translate }}
      </span>
      } @else {
      {{ customListRunDateConfig?.label }}
      @if (!customListRunDateConfig?.isLatestForecast) {
      <span class="run-date-type">
        {{ customListRunDateConfig?.type }}
      </span>
      } }
    </mat-select-trigger>
    <div class="variation-four">
      @for (runDate of options; track runDate; let idx = $index) { @if (idx ===
      0 && !isMultiContinentInCustomList) {
      <mat-option
        [value]="runDate.id"
        [ngStyle]="{ height: '52px', padding: '0' }"
      >
        <div class="radio-options">
          <label class="latest-label">
            <span class="text">
              <span class="latest" translate="latestForecast"></span>
              <span>
                {{
                  runDate.label
                    ? (runDate.label | dateWithoutTimezone : dateFormat)
                    : ''
                }}
                <span class="run-date-type">
                  {{
                    (runDate.type ? runDate.type.toLowerCase() : '') | translate
                  }}
                </span>
              </span>
            </span>
          </label>
        </div>
      </mat-option>
      } @if (idx === 0 && isMultiContinentInCustomList) {
      <mat-option class="custom-list-latest-mat-option" [value]="runDate.id">
        <div class="radio-options">
          <label class="latest-label">
            <span class="text">
              <span class="latest" translate="latestForecast"></span>
            </span>
          </label>
        </div>
      </mat-option>
      } @if (idx !== 0) {
      <mat-option [value]="runDate.id" [ngStyle]="{ padding: '0' }">
        <div class="radio-options">
          <label>
            <span class="text">
              {{ runDate.label | dateWithoutTimezone : dateFormat }}
              <span class="run-date-type">{{
                (runDate.type ? runDate.type.toLowerCase() : '') | translate
              }}</span>
            </span>
          </label>
        </div>
      </mat-option>
      } }
    </div>
  </mat-select>
</mat-form-field>
}

<!-- VARIATION FIVE -->
@if (type === 'variation-five') {
<mat-form-field
  [ngStyle]="{ width: width }"
  class="variation-five"
  floatLabel="auto"
  [ngClass]="{
    'mat-focused': isDropdownOpen,
    'short-dropdown': isShort
  }"
>
  @if (triggerLabel) {
  <mat-label class="trigger-label">
    <span [translate]="triggerLabel"></span>
  </mat-label>
  }
  <mat-select
    [panelClass]="panelClass || 'variation-five-panelClass'"
    #variationFiveSelector
    disableOptionCentering
    [(ngModel)]="value"
    (selectionChange)="onChangeEvent($event)"
    (opened)="isDropdownOpen = true"
    (closed)="isDropdownOpen = false"
    [disabled]="disabled"
  >
    @for (item of options; track trackByFnGroup($index)) {
    <mat-option
      [value]="item.value"
      (click)="onOptionClick($event, item.isPermitted)"
      class="variation-five__option permission-lock-option"
      [disabled]="!item.isPermitted && item.isPermitted !== undefined"
    >
      @if (item.labelKey) {
      <span class="permission-lock-option__label">{{
        item.labelKey | translate
      }}</span>
      } @else {
      <span class="permission-lock-option__label">{{ item.label }}</span>
      } @if (!item.isPermitted && item.isPermitted !== undefined) {
      <firebird-web-icon
        class="icons"
        [ngClass]="lockIconClass"
        name="lock"
        width="16px"
        height="14px"
        fillColor="#EE8031"
      >
      </firebird-web-icon>
      }
    </mat-option>
    }
  </mat-select>
  @if (group_option) {
  <mat-select [value]="value" disableOptionCentering>
    @for (group of group_option; track trackByFnGroup($index)) {
    <mat-optgroup [label]="group.name | translate">
      @for (item of group.option; track trackByFnGroup($index)) {
      <mat-option [value]="item.value">
        @if (item.labelKey) {
        {{ item.labelKey | translate }}
        }
      </mat-option>
      }
    </mat-optgroup>
    }
  </mat-select>
  }
</mat-form-field>
}

<!-- TODO: All previous variations are incorrect and should be rewritten. -->
<!-- TODO: That is temporary workaround to make firebird-web-dropdown as a shared component-->
@if (type === 'variation-four-shared') {
<mat-form-field
  class="variation-four"
  [ngClass]="{ 'mat-focused': isDropdownOpen }"
  [ngStyle]="{ width: width }"
>
  <mat-select
    [panelClass]="['variation-four-panelClass', panelClass || '']"
    [value]="value"
    disableOptionCentering
    #selector
    (selectionChange)="onChangeEvent($event)"
    (opened)="isDropdownOpen = true"
    (closed)="isDropdownOpen = false"
  >
    <mat-select-trigger>
      {{ getLabel(value) }}
    </mat-select-trigger>
    <mat-radio-group class="variation-four">
      @for (option of options; track option) {
      <mat-option
        [value]="option.value"
        (click)="onOptionClick($event, option.isPermitted)"
        class="permission-lock-option"
        [disabled]="!option.isPermitted"
      >
        <div class="radio-options">
          <label>
            <input
              type="radio"
              [checked]="value === option.value"
              name="dropdown"
              [value]="option.value"
              [disabled]="!option.isPermitted"
            />
            <span class="img"></span>
            <span
              class="permission-lock-option__label"
              [ngClass]="{
                text: option.isPermitted,
                'disabled-text': !option.isPermitted
              }"
            >
              {{ option.labelKey }}
            </span>
            @if (!option.isPermitted) {
            <firebird-web-icon
              class="icons"
              name="lock"
              width="16px"
              height="14px"
              fillColor="#EE8031"
            >
            </firebird-web-icon>
            }
          </label>
        </div>
      </mat-option>
      }
    </mat-radio-group>
  </mat-select>
</mat-form-field>
}
